"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnArrowIcon = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const colors_1 = require("../../../../../assets/styles/colors");
const ReturnArrowIcon = ({ color = colors_1.gray300, width = 20, height = 20, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("svg", { width: width, height: height, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": t("thresholdConfigurator.altResetButton") },
        react_1.default.createElement("path", { d: "M7.5 12.5L2.5 7.5M2.5 7.5L7.5 2.5M2.5 7.5H12.5C15.2614 7.5 17.5 9.73858 17.5 12.5C17.5 15.2614 15.2614 17.5 12.5 17.5H10", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.ReturnArrowIcon = ReturnArrowIcon;
